module.exports = __webpack_public_path__ + "static/img/fs1-2.488be13.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/SaveFile/fs1-2.png
// module id = 841
// module chunks = 0